import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, FormCheckbox, Row } from '@monorepo/react-components';
import { NyseFormProps } from '../nyse-modal-content';

import './nyse-steps.scss';

const NyseStepFour: FunctionComponent<NyseFormProps> = ({ form }) => {
  const { t } = useTranslation(['common', 'contractModal']);

  return (
    <div className={'contracts-steps-body'}>
      <ol>
        <li>{t('contractModal:nyse_modal.dissemination_discontinuance')}</li>
        <li>{t('contractModal:nyse_modal.duration_survival')}</li>
        <li>{t('contractModal:nyse_modal.miscellaneous')}</li>
        <li>
          <Row gutter={8}>
            <Col className={'agreement-check'}>
              <FormCheckbox
                form={form}
                controllerProps={{ name: 'firstAgreement' }}
              />
            </Col>
            <Col>
              <span>{t('common:agree')}</span>
            </Col>
          </Row>
        </li>
      </ol>
    </div>
  );
};

export default NyseStepFour;
